import api from '@/api'

export default {

  // 查询记录列表
  recordListSystem (params) {
    return api({
      method: 'GET',
      url: '/record/recordPageSystem',
      params
    })
  },

  // 添加记录
  addRecord (data) {
    return api({
      url: '/record/recordAdd',
      method: 'POST',
      data
    })
  },

  // 编辑记录
  editRecord (data) {
    return api({
      url: '/record/recordEdit',
      method: 'PUT',
      data
    })
  },

  // 获取编辑记录信息
  getRecordInfo (recordUuid) {
    return api({
      url: `/record/recordInfo/${recordUuid}`,
      method: 'GET'
    })
  },

  // 删除记录信息
  deleteRecord (recordUuid) {
    return api({
      url: `/record/recordRemove/${recordUuid}`,
      method: 'DELETE'
    })
  },

  // 查询机构提交球队记录列表--系统管理员/技术支持调用
  recordYouthToSquadListSystem (params) {
    return api({
      method: 'GET',
      url: '/record/recordYouthToSquadPageSystem',
      params
    })
  },

  recordYouthToSquadListOrgan (params) {
    return api({
      method: 'GET',
      url: '/record/recordYouthToSquadPageOrgan',
      params
    })
  },

  // 查询机构提交球队记录列表--青训中心调用
  recordYouthToSquadListYouth (params) {
    return api({
      method: 'GET',
      url: '/record/recordYouthToSquadPageYouth',
      params
    })
  },

  // 查询机构提交球员记录列表--系统管理员/技术支持调用
  recordYouthToPlayerListSystem (params) {
    return api({
      method: 'GET',
      url: '/record/recordYouthToPlayerPageSystem',
      params
    })
  },

  // 查询机构提交球员记录列表--青训中心调用
  recordYouthToPlayerListYouth (params) {
    return api({
      method: 'GET',
      url: '/record/recordYouthToPlayerPageYouth',
      params
    })
  },

  // 添加机构输送球队表
  addRecordYouthToSquad (data) {
    return api({
      url: '/record/recordYouthToSquadAdd',
      method: 'POST',
      data
    })
  },

  // 编辑机构输送球队表
  editRecordYouthToSquad (data) {
    return api({
      url: '/record/recordYouthToSquadEdit',
      method: 'PUT',
      data
    })
  },

  // 审核机构输送球队
  auditRecordYouthToSquad (data) {
    return api({
      url: `/record/recordYouthToSquadAudit`,
      method: 'POST',
      data
    })
  },

  // 获取编辑机构输送球队信息
  getRecordYouthToSquadInfo (squadUuid) {
    return api({
      url: `/record/recordYouthToSquadInfo/${squadUuid}`,
      method: 'GET'
    })
  },

  // 删除机构输送球队信息
  deleteRecordYouthToSquad (squadUuid) {
    return api({
      url: `/record/recordYouthToSquadRemove/${squadUuid}`,
      method: 'DELETE'
    })
  },



  // 添加机构证明材料表
  addRecordProve (data) {
    return api({
      url: '/record/recordProveAdd',
      method: 'POST',
      data
    })
  },

  // 编辑机构证明材料表
  editRecordProve (data) {
    return api({
      url: '/record/recordProveEdit',
      method: 'PUT',
      data
    })
  },

  // 获取机构证明材料信息
  getRecordProveInfo (recordUuid,objUuid,recordType) {
    return api({
      url: `/record/recordProveInfo/${recordUuid}/${objUuid}/${recordType}`,
      method: 'GET'
    })
  },

  // 删除机构证明材料文件
  deleteRecordProveFile (uuid) {
    return api({
      url: `/record/recordProveFileRemove/${uuid}`,
      method: 'DELETE'
    })
  },



  // =========== 集训 ===========



  // 添加机构输送球员表
  addRecordYouthToPlayer (data) {
    return api({
      url: '/record/recordYouthToPlayerAdd',
      method: 'POST',
      data
    })
  },

  // 编辑机构输送球员表
  editRecordYouthToPlayer (data) {
    return api({
      url: '/record/recordYouthToPlayerEdit',
      method: 'PUT',
      data
    })
  },

  // 审核机构输送球员
  auditRecordYouthToPlayer (data) {
    return api({
      url: `/record/recordYouthToPlayerAudit`,
      method: 'POST',
      data
    })
  },

  // 获取编辑机构输送球员信息
  getRecordYouthToPlayerInfo (recordYouthUuid) {
    return api({
      url: `/record/recordYouthToPlayerInfo/${recordYouthUuid}`,
      method: 'GET'
    })
  },

  // 获取编辑机构输送球员信息
  getRecordYouthInfo (recordUuid) {
    return api({
      url: `/record/recordYouthInfo/${recordUuid}`,
      method: 'GET'
    })
  },

  // 删除机构输送球队信息
  deleteRecordYouthToPlayer (playerUuid,recordYouthUuid,score) {
    return api({
      url: `/record/recordYouthToPlayerRemove/${playerUuid}/${recordYouthUuid}/${score}`,
      method: 'DELETE'
    })
  },



  // =========== 上海足协审核 ===========
  recordAuditLogAdd (data) {
    return api({
      url: `/record/recordAuditLogAdd`,
      method: 'POST',
      data
    })
  },

  // 获取审核日志列表
  getRecordAuditList (recordUuid,objUuid,recordType) {
    return api({
      url: `/record/recordAuditList/${recordUuid}/${objUuid}/${recordType}`,
      method: 'GET'
    })
  },

  // 获取审核日志列表
  getRecordSumAuditRanking (recordYear) {
    return api({
      url: `/record/recordSumAuditRanking/${recordYear}`,
      method: 'GET'
    })
  },

  // 获取审核日志列表
  getRecordAuditRanking (recordYear,recordType) {
    return api({
      url: `/record/recordAuditRanking/${recordYear}/${recordType}`,
      method: 'GET'
    })
  },

  // 获取查询记录列表
  getRecordList (recordYear,recordType) {
    return api({
      url: `/record/recordList/${recordYear}/${recordType}`,
      method: 'GET'
    })
  },
  getRecordMatchAll (recordYear) {
    return api({
      url: `/record/recordMatchAll/${recordYear}`,
      method: 'GET'
    })
  },


}
